import { API_BASE_URL, authFetch, getHeaders } from './authFetch';

export type NotificationMode = 'agent' | 'doc-agent' | 'gtc-agent' | 'purchase-agent';
export type NotificationSound = 'chime' | 'bell' | 'soft';
export interface NotificationSettings { sound_enabled: boolean; sound: NotificationSound }
export interface CompletionInput {
  event_id: string; workspace_type: NotificationMode; title: string;
  item_id?: string | null; document_id?: string | null;
}
export interface CompletionNotification extends Omit<CompletionInput, 'event_id'> {
  notification_id: string; created_at: string; read_at: string | null;
}
export interface NotificationPage {
  items: CompletionNotification[]; total: number; unread_count: number; settings: NotificationSettings;
}
async function call<T>(path: string, method = 'GET', body?: unknown): Promise<T> {
  const response = await authFetch(`${API_BASE_URL}/api/v1/notifications${path}`, {
    method, headers: getHeaders(), ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response.ok) throw new Error(`Notification request failed (${response.status})`);
  return response.json();
}
export const fetchNotifications = (offset = 0, unreadOnly = false, limit = 50) =>
  call<NotificationPage>(`?offset=${offset}&limit=${limit}&unread_only=${unreadOnly}`);
export const createCompletionNotification = (input: CompletionInput) =>
  call<CompletionNotification>('/completions', 'POST', input);
export const readNotification = (id: string) => call('/' + encodeURIComponent(id) + '/read', 'POST');
export const readAllNotifications = () => call('/read-all', 'POST');
export const updateNotificationSettings = (settings: Partial<NotificationSettings>) =>
  call<NotificationSettings>('/settings', 'PATCH', settings);

